import {
  expt,
  promt,
  blore,
  mlore,
  udupi,
  personalised,
  cfo,
  audit,
  business,
  comp,
  outsource,
  tax,kundap,gst
} from "../assets";

export const card = [
  {
    title: "Expert Knowledge",
    desc: "A highly skilled financial professional who provides expert advice on accounting, taxation, and financial management to businesses and individuals.",
    img: expt,
  },
  {
    title: "Personalized Solutions",
    desc: "Tailored financial solutions, expert advice, and personalized services for all your accounting and taxation needs.",
    img: personalised,
  },
  {
    title: "Prompt Service",
    desc: "Providing swift and efficient financial and taxation assistance, ensuring timely compliance and expert advisory.",
    img: promt,
  },
];

export const service = [
  {
    title: "Audit & Assurance",
    img: audit,
    desc: "ಗೂಗಲ್ ಫಾರ್ಮ್ ಮುಖೇನ ಸಮಗ್ರ ಪ.ಭೂ ಗಳ ದತ್ತಾಂಶ (Data) ಸಂಗ್ರಹಣೆ (ಸಂಗ್ರಹಿಸಿದ ಡಾಟಾ ದಿಂದ ವರದಿ ತಯಾರಿಸಲು ಅನುಕೂಲವಾಗುತ್ತದೆ).",
  },
  {
    title: "Direct Taxation",
    img: tax,
    desc: "ಇತರೆ ಗುಡಿ ಕೈಕಾರಿಕೆಗಳಿಗೆ ಪ.ಭೂ ಗಳನ್ನು ಪ್ರೋತ್ಸಾಹಿಸುವುದು & ಸರ್ಕಾರದಿಂದ ನೆರವು ಕೊಡಿಸುವ ಮೂಲಕ ಉತ್ತೇಜನ ನೀಡುವುದು.",
  },
  {
    title: "Business Consultancy",
    img: business,
    desc: "ರಿಜಿಸ್ಟರ್ ಆದ ಪ.ಭೂ ಗಳ ತಾಲ್ಲೂಕು ಸಂಘಟನೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಂವಿಧಾನಬದ್ದವಾಗಿ ನಿರ್ಮಿಸುವುದು.",
  },

  {
    title: "Outsourced Accounting",
    img: outsource,
    desc: "ಸಂಘಟನೆಯ ಮುಖೇನ ಇತರೆ ಅಧಿಕಾರಿ ವರ್ಗ, ರಾಜಕೀಯ ವರ್ಗ, ಶಕ್ತ ವರ್ಗಗಳಿಂದ ಪ.ಭೂ ವಿಪತ್ತು ನಿರ್ವಹಣಾ ನಿಧಿಗೆ ದೇಣಿಗೆ ಸಂಗ್ರಹಿಸುವುದು.",
  },
  {
    title: "Virtual CFO",
    img: cfo,
    desc: "ಪದಾಧಿಕಾರಿಗಳ ನೇತೃತ್ವದಲ್ಲಿ ಲೋಕಾಯುಕ್ತ, ಪೋಲೀಸ್ ಕಮೀಷನರ್, ಡಿ.ಸಿ.ಗಳು, ಪತ್ರಿಕೆಯವರು, ವಿಮಾ ಕಂಪನಿಯವರು, ಮಾನವ ಹಕ್ಕುಗಳ ಆಯೋಗ, ಕ್ರೀಡಾ ಇಲಾಖೆ ಅಧಿಕಾರಿಗಳು, ಕರ್ನಾಟಕ ಸಾಹಿತ್ಯ ಪರಿಷತ್ತು ಅಧಿಕಾರಿಗಳು, ಇತರೆ ಉಪಯುಕ್ತ ಇಲಾಖೆಯ ಅಧಿಕಾರಿಗಳ ಸಂಪರ್ಕ ಸಮನ್ವಯ ಸಾಧಿಸುವುದು.",
  },
  {
    title: "Company Compliances",
    img: comp,
    desc: "ಡಿ.ಸಿ ಯವರಿಗೆ ಸಂಘದ ಹೆಸರಿಗೆ ವಸತಿ ರಹಿತ ಪ.ಭೂ ಗಳಿಗೆ ನಿವೇಶನ ನೀಡುವ ಸಲುವಾಗಿ ಬೇಚರಾಕ್ ಗ್ರಾಮಗಳನ್ನು/ಗೋಮಾಳದಲ್ಲಿ ಇಂತಿಷ್ಟು ಜಾಗವನ್ನು ಮಂಜೂರು ಮಾಡಲು ವಿನಂತಿಸಿಕೊಳ್ಳುವುದು.",
  },
 
 
];

export const affiliate = [
  {
    name: "Honnavara",
    img: mlore,
  },
  {
    name: "Manipal",
    img: udupi,
  },
  {
    name: "Moodubidre",
    img: blore,
  },
  {
    name:"Kundapura",
    img: kundap
  }
];
